import Image from "next/image";
import Link from "next/link";

import { ROUTES } from "@/helpers/routes";
import PageSeo from "@/shared/components/PageSeo";

import Layout from "../../shared/components/layout";

export default function StrategicPartnerDetails2() {

    return (
        <div>
            <PageSeo title="mnAi Data Solutions | The Gender Index" pathname={ROUTES.headlinePartnersMnai} />
            <Layout>
                <div className='singleLayout partnerDetailsPage'>
                    <div className='edgeBannerWrapper'>
                        <div className='edgeBanner'>
                        </div>
                        <div className="bannerDetailsWrap">
                            <div className="leftPane">
                                <Link className="backBtn" href="/headline-partners">&lt; Back</Link>
                                <h4>Headline partner</h4>
                                <h1>mnAi</h1>
                                <ul className="commonList link">
                                    <li><a href="https://www.mnai.tech" target="_blank" rel="noreferrer" >www.mnai.tech</a></li>
                                    <li><a href="https://www.linkedin.com/company/mnai" target="_blank" rel="noreferrer">www.linkedin.com/company/mnai</a></li>
                                    <li>@ThisIsmnAI</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="logo-image natwest">
                        {/* <img src="/images/PartnerLogos/mnai.png" alt="logo_image" /> */}
                        <Image
                            src="/images/PartnerLogos/mnai.png"
                            alt="logo_image"
                            width={129}
                            height={50}
                            loading="lazy"
                        />
                    </div>
                    <p className='body-default-copy-large'>mnAi, a distinguished multi-award-winning data, insight, and analytics platform, leverages proprietary technology to
                        deliver advanced research, analytics, and due diligence services for all UK companies. With an expansive dataset
                        comprising 12 billion+ data points covering over 11 million UK companies, mnAi has earned the trust of clients relying
                        on its capability to protect, strengthen and elevate their business operations. We believe that data technology can
                        empower rapid change and are proud to work with leading organisations who share these values.</p>
                    <h6>Why mnAi is supporting The Gender Index:</h6>
                    <p className='body-default-copy-large'>The inception of a national, real-time gender-disaggregated dataset by mnAi marks a paradigm shift, illustrating the
                        profound impact of big data on enhancing socially responsible decision-making processes. By furnishing this real-
                        time data baseline, mnAi is a significant contributor to policy development, empowering policymakers, corporates, and
                        stakeholders dedicated to effecting positive change for women in enterprise. The promotion of a data-driven approach
                        to decision-making ensures that these improvements can be widely disseminated, easily understood, and, in turn,
                        generate greater strategic insight to continually enhance future engagement.</p>
                    <h6>How mnAi can help businesses interested in promoting female entrepreneurship:</h6>
                    <p className='body-default-copy-large'>mnAi plays a pivotal role in empowering individual businesses to promote female entrepreneurship through its
                        comprehensive dataset. Having mapped the ownership and officer profiles of all UK companies, mnAi allows these
                        businesses to understand the diverse landscape within their entire portfolio aiding them in identifying opportunities
                        to support and collaborate with female-led enterprises. mnAi’s encompassing array of financial and non-financial data
                        points, coupled with its comprehensive gender data, transforms into a strategic cornerstone for businesses aiming
                        to champion diversity and inclusivity. The data allows them to make informed decisions that not only benefit their
                        own growth but also contribute to the advancement of female entrepreneurs in the wider business community. By
                        leveraging mnAi’s insights, businesses can actively participate in and drive positive changes, creating an environment
                        that encourages and supports female-led initiatives.</p>
                    <p className='body-default-copy-large'>mnAi’s data and technnology empowers our clients in critical areas such as risk mitigation, business development and
                        strategic planning to ensure they not only remain well-informed but also gain a competitive advantage in navigating the
                        dynamic landscape of modern business.</p>
                    {/* <div className="flex">
                        <h6 className="mr8">Website:</h6>
                        <a className="linkText" href="www.mnai.tech" target="_blank">www.mnai.tech</a>
                    </div>
                    <div className="flex">
                        <h6 className="mr8">Twitter:</h6>
                        <span>@ThisIsmnAI</span>
                    </div>
                    <div className="flex">
                        <h6 className="mr8">LinkedIn:</h6>
                        <span>@mnai</span>
                    </div> */}
                </div>
            </Layout >
        </div >
    );
}

